module.exports = __webpack_public_path__ + "static/media/plan-TH3-mobile-tc.85417567.png";